import React from 'react';
import './download.css';
import Link from 'next/link';

export default function Download() {
  return (
    <section>
        <Link href="/join-now"><div style={{textTransform: "none" , fontWeight: "normal"}} className="sign-up-btn btn">Sign Up to FLP, Today!</div></Link>
        <div id='download-anchor' className="download-cont">
            <img src="./images/download-app-mockups.png" alt="Download FLP App Now" width="500px"></img>
            <div className="download-text">
                <h2>Download the FLP App now!</h2>
                <p>Stay up to date on your benefits</p>
                <Link href="https://apps.apple.com/za/app/first-loyalty-plus/id1500726431">
                    <img src="./images/apple-app-store-logo.png" alt="Download on the App Store"></img>
                </Link>
                <Link href="https://play.google.com/store/search?q=first+loyalty+plus+app&c=apps">
                    <img src="./images/google-play-badge.png" alt="Get it on Google Play"></img>
                </Link>
            </div>
        </div>
    </section>
  )
}
